<template>
    <div class="mx-n10 mx-sm-n15">
        <canvas id="wagon_b" width="550"  height="500" style="width:100%"></canvas>
        <img id="imgs" src="/public/images/Ground_550x550.png" style="padding-left:0px;display:none;" alt="The Scream"/>
        <img class="plyer-img" onerror="this.onerror=null;this.src='/public/images/User.png';" v-for="shot in shots" v-if="shot.score==4 || shot.score==6" :id=" type == 'batsman' ? 'boundry_player'+shot.bowler_id : 'boundry_player'+shot.batsman_id" :src=" type == 'batsman' ? 'https://api.planetcricket.com/resizeImage.php?src=https://img.sixlogics.com/avatars/cricket/players/300x300/'+shot.bowler_id+'.png&w=38&zc=1&q=90&s=1' : 'https://api.planetcricket.com/resizeImage.php?src=https://img.sixlogics.com/avatars/cricket/players/300x300/'+shot.batsman_id+'.png&w=38&zc=1&q=90&s=1'" style="padding-left:0px;display:none;" alt=""/>
        <img onerror="this.onerror=null;this.src='/public/images/User.png';" id="center_player" v-if="centerPlayerId" :src="'https://api.planetcricket.com/resizeImage.php?src=https://img.sixlogics.com/avatars/cricket/players/300x300/'+centerPlayerId+'.png&w=45&zc=1&q=90&s=1'" style="padding-left:0px;display:none;" alt=""/>
    
    </div>
    
</template>

<script>

  export default {
        name: 'wagon',
        
        props: {
         shots:'',
         type: String
         },
        data() {
            return {
               centerPlayerId:0,
                ctx : null,
                canvas : null,
                img:null,
                anglescore:null,
                longOn:0,
                midWicket:0,
                squareleg:0,
                fineLeg:0,
                thirdMan:0,
                point:0,
                cover:0,
                longOff:0,
            }
        },
        mounted() {
var _this = this;
if(_this.shots!='' || _this.shots!='')
{
_this.centerPlayerId = _this.type == 'batsman' ? _this.shots[0].batsman_id : _this.shots[0].bowler_id;
}
else
{
  _this.centerPlayerId =0;
}
setTimeout(function(){
                _this.canvas = window.document.getElementById('wagon_b')
                _this.ctx = _this.canvas.getContext('2d')
                _this.img = window.document.getElementById('imgs')
                _this.ctx.drawImage(_this.img,0,0)
                _this.shots.forEach(shot => {
                _this.ctx.beginPath();
                _this.ctx.moveTo(276, 255);
                 _this.ctx.lineTo(shot.x,shot.y);
                    if(shot.score==4 || shot.score==6)
                    {
                        if(shot.score==6)
                        {
                           _this.ctx.strokeStyle='#ed2225';
                        }
                        else if(shot.score==4)
                        {
                           _this.ctx.strokeStyle='#b144ff';
                        }
                        if(shot.angle>0 && shot.angle<=48)
                        {
                           _this.ctx.stroke();
                           _this.ctx.beginPath();
                           _this.ctx.arc(shot.x+2,shot.y+15, 25, 0, 2 * Math.PI);
                           _this.ctx.fillStyle = '#d1cfcb';
                           _this.ctx.fill();
                          
                           let boundryPlayerId = _this.type == 'batsman' ? shot.bowler_id : shot.batsman_id;
                           _this.ctx.drawImage(document.getElementById('boundry_player'+boundryPlayerId),shot.x+21,shot.y+30,-38,-38);
                        }
                        else if(shot.angle>48 && shot.angle<=90)
                        {
                           _this.ctx.stroke();
                           _this.ctx.beginPath();
                           _this.ctx.arc(shot.x+6,shot.y-13, 25, 0, 2 * Math.PI);
                           _this.ctx.fillStyle = '#d1cfcb';
                           _this.ctx.fill();
                           let boundryPlayerId = _this.type == 'batsman' ? shot.bowler_id : shot.batsman_id;
                           _this.ctx.drawImage(document.getElementById('boundry_player'+boundryPlayerId),shot.x+25,shot.y+3,-38,-38);
                        }
                        else if(shot.angle>90 && shot.angle<=136)
                        { 
                           _this.ctx.stroke();
                           _this.ctx.beginPath();
                           _this.ctx.arc(shot.x+14,shot.y-15, 25, 0, 2 * Math.PI);
                           _this.ctx.fillStyle = '#d1cfcb';
                           _this.ctx.fill();
                           let boundryPlayerId = _this.type == 'batsman' ? shot.bowler_id : shot.batsman_id;
                           _this.ctx.drawImage(document.getElementById('boundry_player'+boundryPlayerId),shot.x+33,shot.y+2,-38,-38);
                        }
                        else  if(shot.angle>136 && shot.angle<=178)
                        {
                            _this.ctx.stroke();
                            _this.ctx.beginPath();
                            _this.ctx.arc(shot.x+5,shot.y-15, 25, 0, 2 * Math.PI);
                            _this.ctx.fillStyle = '#d1cfcb';
                            _this.ctx.fill();
                            let boundryPlayerId = _this.type == 'batsman' ? shot.bowler_id : shot.batsman_id;
                            _this.ctx.drawImage(document.getElementById('boundry_player'+boundryPlayerId),shot.x+25,shot.y+2,-38,-38);
                        }
                        else if(shot.angle>178 && shot.angle<=225)
                        {
                           _this.ctx.stroke();
                           _this.ctx.beginPath();
                           _this.ctx.arc(shot.x-5,shot.y-15, 25, 0, 2 * Math.PI);
                           _this.ctx.fillStyle = '#d1cfcb';
                           _this.ctx.fill();
                           let boundryPlayerId = _this.type == 'batsman' ? shot.bowler_id : shot.batsman_id;
                           _this.ctx.drawImage(document.getElementById('boundry_player'+boundryPlayerId),shot.x+13,shot.y+2,-38,-38);
                        }
                        else if(shot.angle>225 && shot.angle<=272)
                        {
                            _this.ctx.stroke();
                            _this.ctx.beginPath();
                            _this.ctx.arc(shot.x-13,shot.y, 25, 0, 2 * Math.PI);
                            _this.ctx.fillStyle = '#d1cfcb';
                            _this.ctx.fill();
                            let boundryPlayerId = _this.type == 'batsman' ? shot.bowler_id : shot.batsman_id;
                            _this.ctx.drawImage(document.getElementById('boundry_player'+boundryPlayerId),shot.x+6,shot.y+16,-38,-38);
                        }
                        else  if(shot.angle>272 && shot.angle<=313)
                        {
                            _this.ctx.stroke();
                            _this.ctx.beginPath();
                            _this.ctx.arc(shot.x-16,shot.y+5, 25, 0, 2 * Math.PI);
                            _this.ctx.fillStyle = '#d1cfcb';
                            _this.ctx.fill();
                            let boundryPlayerId = _this.type == 'batsman' ? shot.bowler_id : shot.batsman_id;
                            _this.ctx.drawImage(document.getElementById('boundry_player'+boundryPlayerId),shot.x+3,shot.y+20,-38,-38);
                        }
                        else if(shot.angle>313 && shot.angle<=380)
                        {
                            _this.ctx.stroke();
                            _this.ctx.beginPath();
                            _this.ctx.arc(shot.x-2,shot.y+15, 25, 0, 2 * Math.PI);
                            _this.ctx.fillStyle = '#d1cfcb';
                            _this.ctx.fill();
                            let boundryPlayerId = _this.type == 'batsman' ? shot.bowler_id : shot.batsman_id;
                            _this.ctx.drawImage(document.getElementById('boundry_player'+boundryPlayerId),shot.x+17,shot.y+32,-38,-38);
                        }
                        else
                        {
                           let boundryPlayerId = _this.type == 'batsman' ? shot.bowler_id : shot.batsman_id;
                          _this.ctx.drawImage(document.getElementById('boundry_player'+boundryPlayerId),shot.x,shot.y,-20,-20);
                        }
                     
                    }
                    
                     if(shot.score==1)
                    {
                      _this.ctx.strokeStyle='#1c73dc';
                    
                    }
                    else if(shot.score==2)
                    {
                      _this.ctx.strokeStyle='#50f3bc';
                    }
                    else if(shot.score==3)
                    {
                      _this.ctx.strokeStyle='#ffdd00';
                    }
                      _this.ctx.lineWidth = 2;
                    _this.ctx.stroke();
                    _this.ctx.beginPath();
                    
                     _this.ctx.arc(275, 258, 30, 0, 2 * Math.PI);
                     _this.ctx.fillStyle = '#d1cfcb';
                     _this.ctx.fill();
                    _this.ctx.drawImage(document.getElementById('center_player'),253,232);
                });
                },1000)     
        },
        methods:{
            
        }
  }
</script>